<div class="input-area-container" [ngClass]="containerCss">
  <label [ngClass]="[labelCss, labelRequired ? 'label-required' : '']" *ngIf="label">{{ label }}</label>
  <div *ngIf="displaySkeleton" class="display-flex flex-column fill skeleton-loader" [ngClass]="[inputCss]"></div>

  <div
    *ngIf="displaySkeleton && displayCounter"
    class="display-flex justify-content-space-between skeleton-loader"
    [ngClass]="{ 'counter-skeleton-small-font': displaySkeleton && isSmallFont }"></div>

  <div *ngIf="!displaySkeleton" class="display-flex flex-column fill">
    <div class="text-area-wrapper" [ngClass]="{ 'force-placeholder': forcePlaceholder }">
      <textarea
        #textArea
        [readonly]="inputDisabled"
        aria-label="Input Area"
        rows="1"
        matInput
        appCustomTooltip
        [class.focus-in]="focusIn"
        [showToolTip]="displayNewLineHint"
        [contentTemplate]="textAreaTooltipTemplate"
        [appAutoresize]="autoresize"
        [maxHeight]="maxHeight"
        (keydown.enter)="enter($event)"
        (keydown.meta.enter)="insertNewline($event)"
        (keydown.control.enter)="insertNewline($event)"
        (focusin)="onFocusIn()"
        (focusout)="onFocusOut()"
        [ngClass]="[
          inputCss,
          (invalid && showValidationErrorOrSubmitted) ||
          markAsInvalid ||
          (displayCounter && control?.value?.length > maxCounter)
            ? 'invalid'
            : '',
          errors ? 'error-section' : '',
          control.value ? 'filled' : '',
          disabled ? 'disabled' : '',
          isSmallFont ? 'small-font' : 'standard-font'
        ]"
        [formControl]="control"
        [placeholder]="forcePlaceholder ? '' : attrPlaceholder"
        [name]="attrName"
        [attr.aria-invalid]="invalid && showValidationErrorOrSubmitted"
        [attr.disabled]="disabled ? true : null"
        [class.force-placeholder-text]="forcePlaceholder"
        (blur)="onBlur()"></textarea>
      <span *ngIf="forcePlaceholder && attrPlaceholder" class="forced-placeholder">{{ attrPlaceholder }}</span>
    </div>
    <div class="display-flex justify-content-space-between">
      <div
        *ngIf="displayCounter"
        class="placeholder counter"
        [ngClass]="{
          red3: control?.value?.length > maxCounter,
          'counter-small-font': isSmallFont
        }">
        [{{ control?.value?.length || 0 }}/{{ maxCounter }}]
      </div>
    </div>
    <app-input-error
      *ngIf="errorSection && errors"
      [errors]="errors"
      [visible]="markAsInvalid || (errors && showValidationErrorOrSubmitted)"></app-input-error>
  </div>
</div>

<ng-template #textAreaTooltipTemplate>
  <div class="custom-text-area-tooltip-content">
    <div class="body-small text-color gray11">ctr/cmd + enter: new line</div>
  </div>
</ng-template>
